module.exports = __webpack_public_path__ + "img/coinbase-main-buy-sell-screen.0e6d1037.webp";